import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { validateTranslationKey } from '../Language/types';

/**
 * Hook that provides translation with validation
 * @param {Object} translationGroup - Group of valid translations to check against
 * @returns {Object} Object containing validated translation function
 */
const useValidatedTranslation = (translationGroup) => {
    const { t } = useTranslation();

    const vt = useCallback((key, options = {}) => {
        if (process.env.NODE_ENV !== 'production') {
            if (!validateTranslationKey(key, translationGroup)) {
                console.warn(
                    `Invalid translation key: "${key}" in group:`,
                    translationGroup
                );
                return key;
            }
        }
        return t(key, options);
    }, [t, translationGroup]);

    return { vt, t };
};

export default useValidatedTranslation;
